/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type LanguageLocale = typeof LanguageLocale[keyof typeof LanguageLocale];


export const LanguageLocale = {
  de: 'de',
  it: 'it',
} as const;
